export const ActivityKeys = {
	all: ["activities"] as const,
	detail: (id: number | null) => [...ActivityKeys.all, "detail", id] as const,
	detailNotes: (id: number | null) =>
		[...ActivityKeys.all, "detail-notes", id] as const,
	detailAgents: (id: number | null) =>
		[...ActivityKeys.all, "detail-agents", id] as const,
	detailParticipants: (id: number | null) =>
		[...ActivityKeys.all, "detail-participants", id] as const,
	lists: () => [...ActivityKeys.all, "list"] as const,
	infiniteList: (
		filterDatefrom?: string,
		filterDateto?: string,
		filterOnlyunsolved?: boolean,
		filterOnlysolved?: boolean,
		filterSortdesc?: boolean,
		pageSize?: number,
	) =>
		[
			...ActivityKeys.lists(),
			"infinite",
			{
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				filterSortdesc,
				pageSize,
			},
		] as const,
	events: () => [...ActivityKeys.all, "events"] as const,
	infiniteEvents: (
		filterDatefrom?: string,
		filterDateto?: string,
		filterOnlyunsolved?: boolean,
		filterOnlysolved?: boolean,
		filterSortdesc?: boolean,
		pageSize?: number,
	) =>
		[
			...ActivityKeys.events(),
			"infinite",
			{
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				filterSortdesc,
				pageSize,
			},
		] as const,
};
